module.exports = {"38x380": __webpack_public_path__ + "images/fuel-gauge-front-380x38.png"};